import * as _ from 'lodash';
import URI from 'urijs';
import axios from 'axios';
import watermarkApi from '../store/watermarkApi2';

class Utils {
  /* @ngInject */
  constructor() {
    this._cache = {};
    this._refs = {};
    this._params = {};
    this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';

    this.openManagePhotos = this.openManagePhotos.bind(this);

    try {
      document.domain = 'wix.com';
    } catch (e) {
      // console.warn('failed to set domain');
    }
  }

  getOrPutFromCache(fld, func) {
    if (this._cache[fld] !== undefined) {
      return this._cache[fld];
    }
    this._cache[fld] = func();
    return this._cache[fld];
  }

  isInWix() {
    if (this.isSemiNative()) {
      return false;
    }
    return this.getOrPutFromCache('isInWix', () => {
      return ((top !== self) && (document.location.search.indexOf('instance=') >= 0));
    });
  }

  hashToInt(str) {
    var hash = 0;

    if (_.isUndefined(str) || str.length === 0) {
      return hash;
    }
    for (var i = 0; i < str.length; i++) {
      hash += str.charCodeAt(i);
    }
    return hash;
  }

  isDemo() {
    return (this.parseGetParam('demo') === '1');
  }

  addItemHashParam(baseUrl, photoId) {

    var curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
    if (curParamsIndex > 0) {
      baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
    }

    var prefix = '';

    var hashPart = baseUrl.split('#')[1];
    if (hashPart || hashPart == '') {
      var hasQuestionMark = hashPart.split('?')[1];
      if (hasQuestionMark) {
        prefix = '&';
      } else {
        prefix = '?';
      }
    } else {
      prefix = '#?';
    }

    return baseUrl + prefix + 'pro-gallery-item=' + (photoId);

  }

  removeItemHashParam(baseUrl) {
    var itemPart = baseUrl.indexOf('pro-gallery-item=');
    //remove anything after the hash
    var newUrl = baseUrl.substr(0, (itemPart > 0 ? itemPart - 1 : baseUrl.length));
    newUrl += (newUrl.indexOf('#') > 0) ? '' : '#';
    return newUrl;
  }

  parsePathParam(val) {
    var path = location.pathname;
    var pathArr = path.split('/');
    for (var i = 0; i < pathArr.length; i++) {
      var param = pathArr[i];
      if (param.indexOf(val) >= 0) {
        return param;
      }
    }
    return '';
  }

  parseGetParam(val, url) {

    if (!_.isUndefined(this._params[val])) {
      return this._params[val];
    }

    var result = '',
      tmp = [];

    var _location = location;

    if (url) {
      _location = {
        search: '?' + (url.split('?')[1] || ''),
        pathname: ((url.split('?')[0] || '').split('/')[1] || '')
      };
    }

    _location.search
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });

    if (!result) {

      //if the param was not found in the search, try decoding the path
      var query = decodeURIComponent(_location.pathname).split('?')[1];
      if (!query) {
        return '';
      }

      query
        .split('&')
        .forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
    }

    this._params[val] = result;

    return result;
  }

  parseHashParam(val) {
    var result = '';
    var tmp = [];
    var hashPart = location.href.split('#')[1] || '';

    if (!hashPart) {
      return '';
    }

    hashPart
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });
    return result;
  }

  stripSlashes(str) {
    var newStr = '';
    if (typeof str == 'string') {
      newStr = str
        .replace(/\\\//g, '/')
        .replace(/\\'/g, '\'')
        .replace(/\\"/g, '"')
        .replace(/\\0/g, '\0')
        .replace(/\\\\/g, '\\');
    }
    return newStr;
  }

  isSmallScreen() {
    return (window.innerWidth < 640) || this.isMobile();
  }

  isVerticalScreen() {
    return (window.innerWidth < window.innerHeight);
  }

  getDevicePixelRatio() {
    return window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI; // Support for IE10
  }

  isWixMobile() {
    let _isWixMobile = () => {
      var deviceType = this.parseGetParam('deviceType');
      if (deviceType) {
        return (String(deviceType).indexOf('mobile') >= 0);
      } else {
        return undefined;
      }
    };

    if (!this.isSite()) {
      return _isWixMobile();
    } else {
      return this.getOrPutFromCache('isWixMobile', _isWixMobile);
    }

  }

  getDeviceType() {
    return this.isWixMobile() ? 'mobile' : 'desktop';
  }

  isUserAgentMobile() {

    let _isUserAgentMobile = () => {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|pixel|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window['opera']);
      return check;
    };

    if (!this.isSite()) {
      return _isUserAgentMobile();
    } else {
      return this.getOrPutFromCache('isUserAgentMobile', _isUserAgentMobile);
    }
  }

  isMobile() {
    if (this.isSemiNative()) {
      return false;
    }

    let _isMobile = () => {
      var isWixMobile = this.isWixMobile();
      var isUserAgentMobile = this.isUserAgentMobile();

      return (_.isUndefined(isWixMobile) ? isUserAgentMobile : isWixMobile);
    };

    if (!this.isSite()) {
      return _isMobile();
    } else {
      return this.getOrPutFromCache('isMobile', _isMobile);
    }
  }

  isMobileViewer() {
    if (this.isSite() && !_.isUndefined(this._cache.isMobileViewer)) {
      return this._cache.isMobileViewer;
    }

    var isWixMobile = this.isWixMobile();
    var isUserAgentMobile = this.isUserAgentMobile();

    this._cache.isMobileViewer = isWixMobile && !isUserAgentMobile;
    return this._cache.isMobileViewer;
  }

  isiOS() {
    return this.getOrPutFromCache('isiOS', () => {
      return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream']);
    });
  }

  isiPhone() {
    return this.getOrPutFromCache('isiPhone', function () {
      return /iPhone/.test(navigator.userAgent) && !window['MSStream'];
    });
  }

  isTouch() {
    return this.getOrPutFromCache('isTouch', () => {
      return ('ontouchstart' in document.documentElement);
    });
  }

  browserIs(browserName) {

    if (_.isUndefined(this._cache.browsers)) {

      var browsers = {
        chrome: false,
        chromeIos: false,
        explorer: false,
        firefox: false,
        safari: false,
        opera: false,
      };

      browsers.chrome = navigator.userAgent.indexOf('Chrome') > -1;
      browsers.chromeIos = navigator.userAgent.indexOf('CriOS') > -1;
      browsers.explorer = navigator.userAgent.indexOf('MSIE') > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./); // support for edge
      browsers.firefox = navigator.userAgent.indexOf('Firefox') > -1;
      browsers.safari = navigator.userAgent.indexOf('Safari') > -1;
      browsers.opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

      if ((browsers.chrome) && (browsers.safari)) {
        browsers.safari = false;
      }

      if ((browsers.chrome) && (browsers.opera)) {
        browsers.chrome = false;
      }

      this._cache.browsers = browsers;

    }

    return this._cache.browsers[browserName];
  }

  deviceHasMemoryIssues() {
    return this.isiOS();
  }

  getUrlPrefix(forceProduction) {
    return (window.location.protocol + '//' + ((!forceProduction && this.isLocal()) ? 'local.wix.com:3001' : 'progallery.wix.com') + '/');
  }

  getFullscreenSectionId() {
    var isStore = this.isStoreGallery();
    return isStore ? 'fullscreen_store_page' : 'fullscreen_page';
  }

  getApiUrlPrefix() {
    return this.getUrlPrefix(true) + 'api/v1/';
  }

  generateUrl(endpointFile, params) {
    params = params || {};
    var isStore = this.isStoreGallery();
    var url = this.getUrlPrefix() + endpointFile;
    var uri = new URI(url);

    if (isStore) {
      params['isStore'] = true;
    }

    uri.search(params);
    return uri.toString();
  }

  getManageMediaUrl() {
    return this.generateUrl('photos.html');
  }

  getExpandSettingsUrl() {
    return this.generateUrl('settings-expand.html');
  }

  getSettingsWatermarkDisableUrl() {
    return this.generateUrl('settings-watermark-disable.html');
  }

  getSettingsAddonsUrl(params = {}) {
    return this.generateUrl('settings-addons.html', params);
  }

  getProviderModalUrl(params = {}) {
    return this.generateUrl('provider-modal.html', params);
  }

  isTest() {
    //the test driver will override this method to set it to true;
    return false;
  }

  isSemiNative() {
    return window['semiNative'];
  }

  isDev() {
    if (this.isSemiNative()) {
      return true;
    }

    var ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]{1,5}/; //matches 111.222.333.444:9999
    var isDev = this.isLocal();

    if (!_.isUndefined(this._cache.isDev)) {
      return this._cache.isDev;
    }

    isDev = isDev || (this.shouldDebug('ph_local'));
    isDev = isDev || (this.parseGetParam('debug') == 'true');
    isDev = isDev || ((this.safeLocalStorage() || {})['forceDevMode'] == 'true');
    this._cache.isDev = isDev;
    return isDev;
  }

  isVerbose() {
    return ((this.safeLocalStorage() || {})['forceDevMode'] == 'true');
  }

  isLocal() {
    var ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]{1,5}/; //matches 111.222.333.444:9999
    var isLocal = false;

    if (!_.isUndefined(this._cache.isLocal)) {
      return this._cache.isLocal;
    }
    var host = window.location.hostname;
    isLocal = isLocal || (host == 'local.wix.com');
    isLocal = isLocal || (host.indexOf('localhost') >= 0);
    isLocal = isLocal || ((ipRegex.exec(host)) !== null);
    this._cache.isLocal = isLocal;
    return isLocal;
  }

  getViewModeFromCache() {
    return this.getOrPutFromCache('viewMode', () => {
      try {
        return Wix && Wix.Utils && Wix.Utils.getViewMode();
      } catch (e) {
        return false
      }
    });
  }

  updateViewMode() {
    //NOTICE: this method must be called after each EDIT_MODE_CHANGED event to clear the cache
    if (Wix.Utils) {
      this._cache.viewMode = Wix.Utils.getViewMode();
      return this._cache.viewMode;
    }
  }

  isEditor() {
    if (!this.isInWix()) {
      return false;
    }
    return (this.getViewModeFromCache() == 'editor');
  }

  isPreview() {
    if (!this.isInWix()) {
      return false;
    }
    return (this.getViewModeFromCache() == 'preview');
  }

  isPlayground() {
    if (this.isInWix()) {
      return false;
    }

    var isPlayground = false;
    try {
      isPlayground = top.location.href.indexOf('playground.html') > 0;
    } catch (e) {
      isPlayground = false;
    }

    return isPlayground;

  }

  isSite() {
    return !this.isPlayground() && !this.isEditor() && !this.isPreview();
  }

  //isWixDomain() {
  //  return window.location.href.indexOf('wix.com') >= 0;
  //}

  getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  setExternalId() {
    let uuid = this.getUUID();
    Wix.Settings.setExternalId(uuid, (success) => {
      this.isDev() && console.log('Utils setExternalId - success', uuid, success);
    }, (error) => {
      this.isDev() && console.log('Utils setExternalId - fail', uuid, error);
    });
  }

  hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  setStateAndLog(that, caller, state, callback) {

    if (this.isVerbose()) { //todo yoshi
      console.log(`State Change Called (${caller})`, state);
      var oldState = _.clone(that.state);
      that['setState'](state, () => {
        var newState = _.clone(that.state);
        var change = this.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log(`State Change Completed (${caller})`, change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that['setState'](state, () => {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  }

  printableObjectsDiff(obj1, obj2, prefix = '') {

    var toString = (v) => {
      if (v == '') {
        v = '\'\'';
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };

    var getInnerDiff = (obj1, obj2, prefix) => {
      var innerDiff = _.reduce(obj1, (res, v, k) => {
        if (!_.isEqual(v, obj2[k])) {
          if (_.isArray(obj2[k])) {
            if (v.length != obj2[k].length) {
              res[k + '.length'] = '[' + (v.length) + '] => [' + (obj2[k].length) + ']';
            }
            res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? (prefix + '.') : '') + k));
          } else if (_.isObject(obj2[k])) {
            res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? (prefix + '.') : '') + k));
          } else {
            res[(prefix ? (prefix + '.') : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
          }
        }
        return res;
      }, {});
      return innerDiff;
    };

    return getInnerDiff(obj1, obj2, prefix);
  }

  getWindow(windowName, verifyParam, compId, instanceId) {
    if (!_.isUndefined(this._refs[windowName])) {
      const cacheWindow = this._refs[windowName];
      if (cacheWindow && cacheWindow.location && cacheWindow.location.href) {
        return this._refs[windowName];
      } else {
        this._refs[windowName] = null;
      }
    }

    for (var d = 0; d < window.parent.frames.length; d++) {
      var frame = window.parent.frames[d];
      try {
        let found = false;
        try {
          if (frame[verifyParam]) {
            found = true;
          }
        } catch (e) {
          // console.warn('couldn\'t access frame', windowName, {d, e});
        }
        if (found) {
          //check if this is the window
          this._refs[windowName] = frame;
          break;
        } else {
          //check if one of this window's children is the one (e.g. when accessing the worker from the settings, the worker is inside the editor's iframe)
          let frames = [];
          if (compId) {
            if (frame.document.getElementById(compId)) {
              frames = frame.document.getElementById(compId).getElementsByTagName('iframe');
            }
          } else {
            frames = frame.document.getElementsByTagName('iframe');
          }

          for (var f = 0; f < frames.length; f++) {
            try {
              var subFrame = frames[f]['contentWindow'];
              if (subFrame[verifyParam]) {
                // console.log('comparing ', instanceId, subFrame.instanceId);
                if (!instanceId || subFrame.instanceId === instanceId) {
                  //check if this is the window
                  this._refs[windowName] = subFrame;
                  break;
                }
              }
            } catch (e) {
              // console.warn('catch frame ', windowName, {d, f, e});
            }
          }
          if (this._refs[windowName]) {
            break;
          }
        }
      } catch (e) {
        // console.warn('catch frame ', windowName, {d, e});
      }
    }

    if (_.isUndefined(this._refs[windowName])) {
      if (this.isVerbose()) {
        console.log('Window ' + windowName + ' not found - using sessionStorage');
      }
      return this.safeSessionStorage();
    }

    return this._refs[windowName];
  }

  getWorkerWindow() {
    if (this.isSemiNative()) {
      return [];
    }
    return this.getWindow('worker', 'isWorker');
  }

  getMultishareWindow() {
    return this.getWindow('multishare', 'isMultishare');
  }

  getGalleryWindow(compId, instanceId) {
    return this.getWindow('gallery', 'isGallery', compId, instanceId);
  }

  getGalleryByCompId(compId) {
    if (_.isUndefined(this._cache.galleries)) {
      this._cache.galleries = {};
    }

    //todo - caching of galleries removed because in some cases it made the window stay at a old version
    //e.g. - adding an image to the gallery (after fullscreen was already opened) and reopening it

    //if (!_.isUndefined(this._cache.galleries[compId])) {
    //  return this._cache.galleries[compId];
    //}

    for (var d = 0; d < window.parent.frames.length; d++) {
      try {
        var frame = window.parent.frames[d];
        if (frame['isGallery'] === true || frame.document.location.href.indexOf(this.getUrlPrefix() + 'gallery') >= 0) {
          if (frame.document.location.href.indexOf('compId=' + compId) >= 0) {
            // console.warn('got gallery by compId', compId, frame, frame['proGalleryWidget']);
            this._cache.galleries[compId] = frame;
          }
        }
      } catch (e) {
        //console.log('catch frame'+ d);
      }
    }
    return this._cache.galleries[compId];
  }

  safeLocalStorage() {
    try {
      return localStorage;
    } catch (e) {
      return window;
    }
  }

  safeSessionStorage() {
    try {
      return sessionStorage;
    } catch (e) {
      return window;
    }
  }

  getLocalStorage() {
    if (this.isDev()) {
      return this.getWorkerWindow();
    } else {
      let _localStorage = this.safeLocalStorage();
      return (_localStorage || this.getWorkerWindow())
    }
  }

  getViewportScaleRatio() {
    //320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return (320 / this.getScreenWidth());
    } else {
      return 1;
    }
  }

  isLandscape() {
    if (this.isSemiNative()) {
      return false;
    }
    if (!_.isUndefined(this._cache.isLandscape)) {
      return this._cache.isLandscape;
    }
    if (!this.isMobile()) {
      this._cache.isLandscape = false;
    }
    if (!_.isUndefined(window.orientation)) {
      this._cache.isLandscape = (window.orientation == 90 || window.orientation == -90);
    } else {
      var mql = window.matchMedia('(orientation: landscape)');
      if (mql && mql.matches == true) {
        this._cache.isLandscape = true;
      } else {
        this._cache.isLandscape = false;
      }
    }
    return this._cache.isLandscape;
  }

  getScreenWidth() {
    if (this.isSemiNative()) {
      return 1920;
    }
    if (this.isLandscape()) {
      return Math.max(window.screen.width, window.screen.height);
    } else {
      return window.screen.width;
    }
  }

  getScreenHeight() {
    if (this.isSemiNative()) {
      return 1200;
    }
    if (this.isLandscape()) {
      return Math.min(window.screen.width, window.screen.height);
    } else {
      return window.screen.height;
    }
  }

  fixViewport(pageName) {
    if (this.isSemiNative()) {
      return;
    }
    this._cache.isLandscape = undefined;
    if (this.isSite() && this.isMobile() && !this.isMobileViewer()) { //using isUserAgentMobile creates a bug in mobile view when configured to show desktop on mobile (so isWixMobile is false)
      if (this.isDev()) {
        console.log(pageName + ' BEFORE: Screen width: ' + window.screen.width);
        console.log(pageName + ' BEFORE: window.innerWidth: ' + window.innerWidth);
        console.log(pageName + ' BEFORE: document.body.clientWidth: ' + document.body.clientWidth);
      }

      var viewportAspectRatio = 320 / this.getScreenWidth();
      document.body.style.transform = 'scale(' + viewportAspectRatio + ')';
      document.body.style.transformOrigin = '0 0';
      document.body.style.width = (100 / viewportAspectRatio) + '%';
      document.body.style.height = (100 / viewportAspectRatio) + '%';
      //(<any>document.getElementsByTagName('html')[0]).style.transform = 'scale(' + viewportAspectRatio + ')';
      //(<any>document.getElementsByTagName('html')[0]).style.transformOrigin = '0 0';
      //(<any>document.getElementsByTagName('html')[0]).style.width = Math.round(100 / viewportAspectRatio) + '%';
      //(<any>document.getElementsByTagName('html')[0]).style.height = Math.round(100 / viewportAspectRatio) + '%';

      if (this.isDev()) {
        console.log(pageName + ' AFTER: Screen width: ' + window.screen.width);
        console.log(pageName + ' AFTER: window.innerWidth: ' + window.innerWidth);
        console.log(pageName + ' AFTER: document.body.clientWidth: ' + document.body.clientWidth);
      }
    }
  }

  getTopUrlParam(name) {
    if (_.isUndefined(this._cache.params)) {
      this._cache.params = {};
    }
    if (_.isUndefined(this._cache.params[name])) {
      try {
        this._cache.params[name] = top.location.search.replace('?', '').split('&').map(function (ele) {
          var arr = ele.split('=');
          return (arr[0] == name ? (arr[1] || '') : '');
        }).join('');
      } catch (e) {
        this._cache.params[name] = false;
        // console.log('caught cross origin error');
        //comment to avoid 'block is empty' from linter
      }
    }
    return this._cache.params[name];
  }

  debounceWithContext(context, debouncedFunction, delay = 300) {
    return (_.bind(_.debounce(debouncedFunction, delay), context));
  }

  openModalImp(url, width = '100%', height = '100%', onClose = _.noop) {
    return new Promise((resolve, reject) => {
      Wix.Settings.openModal(url, width, height, undefined, () => { onClose();
        resolve() }, true, { overlay: 'rgba(0,0,0,0)', background: 'rgba(0,0,0,0)', margin: false });
    });
  }

  isStoreGallery() {
    return this.getOrPutFromCache('isStoreGallery', () => {
      if (this.isSemiNative()) {
        return false;
      }

      try {
        return window.location.search.toLowerCase().indexOf('isstore') > -1
      } catch (e) {
        if (this.isDev()) {
          console.error('cant find window', e);
        }
        return false;
      }
    });
  }

  openManagePhotos() {
    return this.openModalImp(this.getManageMediaUrl());
  }

  openExpandSettings() {
    this.openModalImp(this.getExpandSettingsUrl());
  }

  openSettingsWatermarkDisableDialog(callback) {
    Wix.Settings.openModal(this.getSettingsWatermarkDisableUrl(), 612, 281, undefined, callback, true)
  }

  openSettingsAddonsUrl(params, callback) {
    Wix.Settings.openModal(this.getSettingsAddonsUrl(params), 736, 281, undefined, callback, true)
  }

  findFontsHrefs() {
    try {
      const isFontHref = x => x.toLowerCase().includes('font');

      return Array.from(top.document.styleSheets)
        .map(styleSheet => styleSheet.href)
        .filter(href => href != null)
        .filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  }

  isOnBoarding() {
    let isOnBoarding = false;

    if (URI) {
      let params = new URI(window.location.href).query(true);
      isOnBoarding = params.viewMode && params.viewMode.toLowerCase() === 'onboarding';
    }

    return isOnBoarding;
  }

  getSupportLink(progalleryLinks, storeLinks) {
    let editorArticleId, onBoardingArticleId
    editorArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[0] : progalleryLinks[0] : progalleryLinks[0]
    onBoardingArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[1] : progalleryLinks[1] : progalleryLinks[1]
    var articleUrl = '';
    let isOnboarding = this.isOnBoarding() || !editorArticleId;
    if (editorArticleId || onBoardingArticleId) {
      let widgetCode = '';
      let articleId = '';
      let subDomain = 'support';

      const isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
      const hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;

      if (isOnBoardingReallyExists || hasOnBoardingOnly) {
        widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
        articleId = onBoardingArticleId;
      } else if (editorArticleId) {
        widgetCode = this.CONST_EDITOR_WIDGET_CODE;
        articleId = editorArticleId;
      }

      if (_.isUndefined(window['locale'])) {
        window['locale'] = 'en'
      }

      var locale = window['locale'];
      var path = `/${locale}/widget/${widgetCode}/article/${articleId}`;
      let url = new URI('https://wix.com/').path(path).subdomain(subDomain);
      articleUrl = url.toString();
    }

    return articleUrl;
  }

  mergeDeep() {

    var _mergeDeep = (dstObj, srcObj) => {
      let mergeId;

      // const clonedDstVal = _.cloneDeep(dstObj);
      const res = _.mergeWith(dstObj, srcObj, (dstVal, srcVal) => {
        if (_.isObject(dstVal) && !_.isFunction(dstVal)) { //isObject return true for functions too
          return (_mergeDeep(dstVal, srcVal));
        } else {
          return srcVal;
        }
      });

      return res;
    };

    var merged = {};
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        merged = _mergeDeep(merged, arguments[i]);
      }
    }

    return merged;

  }

  getImageUrl(fileName) {
    return ((window['staticsUrl'] || '') + fileName);
  }

  markWidgetInSite(widgetId) {
    var instanceId = window['instanceId'];
    (this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true);
  }

  isWidgetInSite(widgetId) {
    var instanceId = window['instanceId'];
    return !_.isUndefined(this.getLocalStorage()[instanceId + '|has-widget|' + widgetId]);
  }

  getMobileEnabledClick(action) {
    //todo: bring back this line before pushing to master
    return this.isMobile() ? { onTouchEnd: action } : { onClick: action };
    // return {onClick: action};
  }

  uploadImageFromUrl(imageUrl) {
    var imageUrlTemplateBase64 = window.btoa(imageUrl);
    var updloadMediaUrlTemplate = `http://files.wix.com/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=${encodeURIComponent(imageUrl)}`;

    return this.getUploadMediaRequest(updloadMediaUrlTemplate, 10000);
  }

  getUploadMediaRequest(uploadMediaUrl, timeout) {
    return $.ajax(uploadMediaUrl, {
      method: 'GET',
      dataType: 'json',
      timeout: timeout,
      xhrFields: {
        withCredentials: true
      }
    });
  }

  isInExpendSettings() {
    return this.parseGetParam('expandsettingsmode') === '1';
  }

  isStoreDemoImages() {
    if (this.isDev()) { //development mode cannot upload images so is is default false
      return Promise.resolve(false);
    }
    if (this.isInExpendSettings()) { //expend settings uses default images
      return Promise.resolve(true);
    }

    return this.gallerySettings.get('isStoreDemoImages')
      .then(isDemo => {
        if (isDemo === undefined) {
          throw 'not in gallerySettings, fallback to dataPublic'
        }
        return isDemo
      })
      .catch(e => {
        return this.dataPublic.get('isStoreDemoImages')
          .then(() => {
            return false
          })
          .catch(e => {
            if (this.isDev()) {
              console.log('error fetching store default images', e);
            }
            return !!(e && e.error && e.error.message && (e.error.message.indexOf('not found in APP scope') > 0))
          })
      })
  }

  isInSettings() {
    return (this.parseGetParam('expandsettingsmode') == '1');
  }

  createUniqueUuidFromString(str) {
    const num = this.hashToInt(str);

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c, i) {
      var r = ((num * i) % 16),
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  shouldDebug(str) {
    try {
      return (
        (!!this.safeLocalStorage()[str]) ||
        (window['debugApp'] || '').indexOf(str) >= 0 ||
        (this.parseGetParam('debugApp') || '').indexOf(str) >= 0
      )
    } catch (e) {
      return false;
    }
  }

  isAccessibilityEnabled() {
    return this.shouldDebug('accessibility') || this.isDev();
  }

  getTabIndex(elementName) {
    const elementsArr = [
      'currentGalleryItem',
      'loadMoreButton',
      'slideshowNext',
      'slideshowPrev',
      'currentThumbnail',
      'slideshowLove',
      'slideshowShare',

      'cartIcon',
      'cartClose',
      'cartFrame',

      'fullscreenClose',
      'fullscreenNext',
      'fullscreenPrev',
      'fullscreenInfo',
      // 'fullscreenTitle',
      // 'fullscreenDesc',
      'fullscreenLink',
      'fullscreenProvider',
      'fullscreenCartButton',
      'fullscreenCheckout',
      'fullscreenExpand',
      'fullscreenVideoPlay',
      'fullscreenVideoBar',
      'fullscreenVideoMute',
      'fullscreenVideoVolume',
      'fullscreenDownload',
      'fullscreenLove',
      'fullscreenShare',
    ];

    const elementIdx = elementsArr.indexOf(elementName) + 1;
    return elementIdx || -1; //no tabIndex (tab will not focus on this item)
  }

  dataPublicKey(key) {
    try {
      const compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId();
      return key + '-' + compId;
    } catch (e) {
      // console.error('Cannot get compId', e);
      return key + '-no-comp-id';
    }
  }

  data = {
    set: (key, value) => {
      const dataKey = this.dataPublicKey(key);
      return new Promise((resolve, reject) =>
        Wix.Data.Public.set(dataKey, value, { scope: 'APP' },
          data => resolve(data.dataKey),
          err => reject(err))
      )
    },
    get: key => {
      const dataKey = this.dataPublicKey(key);
      return new Promise((resolve, reject) =>
        Wix.Data.Public.get(dataKey, { scope: 'APP' },
          data => resolve(data.dataKey),
          err => reject(err))
      )
    }
  }

  openMediaDialogAndApplyWatermark(callback) {
    Wix.Dashboard.openMediaDialog(Wix.Settings.MediaType.IMAGE_PRO, true, (result) => {
      let galleryId = window['galleryId']
      let instance = window['instance']
      watermarkApi.applyWatermarkOnMediaDialogResult(result, galleryId, instance).then(watermarkData => {
        callback(result);
      });
    });
  }

  timingMark(name) {
    try {
      window.performance && performance.mark && performance.mark(name)
    } catch (e) {
      console.error('Error in timingMark', e);
    }
  }

  timingMeasure(measureName, startMarkName, endMarkName) {
    try {
      if (window.performance && performance.measure) {
        if (endMarkName) { //performance.measure can't get undefined in ie
          performance.measure(measureName, startMarkName, endMarkName)
        } else if (startMarkName) {
          performance.measure(measureName, startMarkName)
        } else {
          performance.measure(measureName)
        }
      }
    } catch (e) {
      console.error('Error in timingMeasure', e);
    }
  }

  itemLoadStart() {
    if (!window['itemLoadStart']) {
      window['itemLoadStart'] = true
      this.timingMark('itemLoadStart')
    }
  }

  colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      let returnValue = null;
      if (typeof colorString === 'string') {

        if (colorString.trim().indexOf('rgb') === 0) { // rgb(1,2,3) | rgba(4,5,6,0.7)
          const values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2],
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
          });

          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
          returnValue = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
      }

      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  }

  itemLoaded() {
    if (!window['firstItemLoaded']) {
      this.timingMeasure('firstItemLoaded', 'itemLoadStart')
      window['firstItemLoaded'] = true
      try {
        // fedopsLogger.appLoaded()
        const { startTime, duration } = performance.getEntriesByName('firstItemLoaded')[0]
        logger.trackBi(logger.biEvents.pro_gallery_load_uou, { endpoint: 'itemLoadStart', loading_time: Math.round(startTime) })
        logger.trackBi(logger.biEvents.pro_gallery_load_uou, { endpoint: 'firstItemLoadDuration', loading_time: Math.round(duration + startTime) })
      } catch (e) {
        //
      }
    }
  }

  getExperimentValue(experimentName) {
    return _.get(window, ['petri', `specs.pro-gallery.${experimentName}`]);
  }

  gallerySettings = (() => {
    const baseUrl = window.location.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';
    const getGallerySettingsApi = () => `${baseUrl}${window['galleryId']}?instance=${window['instance']}&isStore=${this.isStoreGallery()}`

    return {
      get: (key) => {
        return (axios.get(getGallerySettingsApi(), { withCredentials: true, xsrfCookieName: null }))
          .then(({ data }) => {
            return key ? data.settings[key] : data.settings
          })
      },
      set: (key, value) => {
        return this.gallerySettings.get().then(data => {
            data = data || {}
            const settings = Object.assign(data, {[key]: value})
            return axios.put(getGallerySettingsApi(), {settings}, {withCredentials: true, xsrfCookieName: null}).then(() => this.setExternalId());
          }
        )
      }
    }
  })()
}

export const utils = new Utils();



// WEBPACK FOOTER //
// ./utils/utils.js